import request from './request';

const buildings = {
	async getBuildings(query) {
		const response = await request.get('/app/buildings', query);
		return response;
	}
};

export default buildings;